import React from 'react'
import MoviesBoxMore from '../MoviesBox/MovieBoxMore';
import Navbar from '../Navbar/Navbar';

import Slider from '../Slider/Slider';

const MoviesMore = () => {
  return (
    <>
      <Navbar />
      <Slider />
      <MoviesBoxMore />
    </>
  );
}

export default MoviesMore